import { useTranslation } from 'react-i18next';
import React from 'react';

import { WiderTable } from '@/components';

import { columns } from './columns';
import { useRestrictionRecords, useUserRestricted } from './hooks';
import style from './index.module.scss';

export type RestrictionRecordsProps = {
  address: string;
};

export const RestrictionRecords = ({ address }: RestrictionRecordsProps) => {
  const { t } = useTranslation();

  const { data, isLoading, refetch } = useRestrictionRecords(address);
  const { data: restriction } = useUserRestricted(address);

  return (
    <div className={style.container}>
      {restriction?.is_restricted ? (
        <div className={style.restrictLable}>
          {t('RestrictionRecords.ih7dhl')}
          {restriction._endAt}
          {t('RestrictionRecords.i1smtj')}
        </div>
      ) : null}
      <div className={style.desc}>{t('RestrictionRecords.desc')}</div>
      <WiderTable
        className={style.table}
        columns={columns}
        data={data}
        bodyHeight={368}
        loading={isLoading}
        reload={refetch}
        emptyTitle={t('RestrictionRecords.noRecords')}
      />
    </div>
  );
};
